import { getRuntimeConfig } from '@catawiki/next-config/runtime-config';
import { Http, Query } from '@catawiki/runtime-toolkit';

export const queryClient = Query.createClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (count, error) => {
        if (
          process.env.NODE_ENV === 'test' ||
          getRuntimeConfig().stage === 'test' ||
          Http.isResponseErrorOfStatus(error, Http.NOT_FOUND)
        ) {
          return false;
        }
        return count < 3;
      },
    },
  },
});

export const queryClientTest = Query.createClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: Infinity,
    },
  },
});
